module.exports = __webpack_public_path__ + "static/img/jtindex.a82ac8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/jtindex.png
// module id = byU4
// module chunks = 1